/**
 * Sharing capability names, mirroring supabase/functions/_permissions/capabilities.ts.
 *
 * The frontend needs the NAMES only — capabilities arrive already computed from the
 * server (D13), so the role -> capability map deliberately does not live here.
 *
 * The duplication is structural (no shared package in this repo) and is checked by
 * `yarn check:vocabularies`.
 */
export const CAPABILITIES = {
  READ: 'read',
  SUBMIT_DRAFT: 'submit_draft',
  ATTACH_OWN_AGAMI: 'attach_own_agami',
  MODERATE: 'moderate',
  VIEW_SUBMISSIONS: 'view_submissions',
} as const

export type Capability = (typeof CAPABILITIES)[keyof typeof CAPABILITIES]
